// plugins/vuetify.ts
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

const vuetify = createVuetify({
    ssr: true,
    icons: {
        defaultSet: 'mdi',
        sets: {
            mdi,
        },
        aliases, 
    },
    theme: {
        defaultTheme: 'myCustomTheme',
        themes: {
            myCustomTheme: {
                colors: {
                    primary: '#247DE3', // Mavi
                    darkPrimary: '#001E43', // Koyu Mavi
                    lightPrimary: '#b9c9db', // Açık Mavi
                    text: '#757191', // Gri
                    textWhite: '#DBD9E8', // Beyaz
                    softGrey: '#DBD9E8', // Gri
                    background: '#F6F7F9', // Arka plan rengi beyaz
                    borderGrey: '#EAEAF2', // Border grisi
                    accent: '#82B1FF', // Açık Mavi
                    error: '#FF5A5A', // Kırmızı
                    info: '#2196F3', // Mavi
                    success: '#4CAF50', // Yeşil
                    warning: '#F5D942', // Sarı
                    cardBlueBackground: '#043572', // Kart arka plan rengi
                },
            },
        },
    },
    defaults: {
        VTextField: {
            variant: 'outlined',
        },
        VSelect: {
            variant: 'outlined',
            menuProps: {
                scrollStrategy: 'none',
            },
        },
        VAutocomplete: {
            variant: 'outlined',
            menuProps: {
                scrollStrategy: 'none',
            },
            noDataText: 'Sonuç bulunamadı',
        },
        VMenu: {
            scrollStrategy: 'none',
        },
        VTextarea: {
            variant: 'outlined',
        },
        VBtn: {
            variant: 'flat',
            color: 'primary',
            class: 'text-transform-none',
        },
        VPagination: {
            color: 'primary',
        },

    },
    components: {
        ...components,
        ...labsComponents
    },
    directives,
})

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(vuetify)
})